import { CIMSModal } from 'components/CIMSModal'
import { Typography } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { RepairModalProps } from './types'
import { useState } from 'react'

function RepairModal<T extends object>({
  onClose,
  visible,
  parent,
  options,
  onOk,
  folder,
}: RepairModalProps<T>) {
  const [loading, setLoading] = useState(false)
  return (
    <CIMSModal
      visible={visible}
      onCancel={onClose}
      onOk={async ({ driveItemId }) => {
        setLoading(true)
        await onOk(driveItemId)
        setLoading(false)
        onClose()
      }}
      loading={loading}
      title="Link SharePoint Folder"
    >
      <Typography.Paragraph>
        SharePoint Folder links are no longer generated in real time. Folders
        are associated with each record in the CIMS Database and managed by
        CIMS.
      </Typography.Paragraph>
      <Typography.Paragraph>
        For whatever reason, there doesn't appear to be a link associated with{' '}
        {folder}.
      </Typography.Paragraph>
      <Typography.Paragraph>
        If you feel there should be one, select a folder from the {parent.name}{' '}
        folder to associate with {folder}. The selected folder may be renamed to
        match the expected folder name for {folder}.
      </Typography.Paragraph>
      <CIMSFormItem
        name="driveItemId"
        label="Folder"
        requiredMessage="Please select a folder"
      >
        <CIMSSelect simple options={options} />
      </CIMSFormItem>
      {!options.length && (
        <Typography.Paragraph type="warning">
          Only folders without a link to an existing record are available to
          select. Unfortunately, this record cannot be linked.
        </Typography.Paragraph>
      )}
    </CIMSModal>
  )
}

export default RepairModal
